export enum AlertEventCodes {
    aircraftDeparted = 1001,
    aircraftActive = 1002,
    aircraftArrived = 1003,
    aircraftAgedOut = 1004,
    aircraftDestinationChanged = 1005,
    aircraftEtaChanged = 1006,
    aircraftFlightPlanChanged = 1007,
    aircraftPositionUpdated = 1008,
    aircraftNearDestination = 1009,
    aircraftEnteredArea = 1010,
    aircraftLeftArea = 1011,
    aircraftFlightPlanReceived = 1013,
    aircraftScheduleReceived = 1014,
    aircraftEdctUpdated = 1015,
    aircraftCtaUpdated = 1018,
    aircraftPastDepartureTime = 1016,
    aircraftEtdUpdated = 1017,
    aircraftTaxiTimeWarning = 1040,
    aircraftTaxiTimeCritical = 1041,
    aircraftTaxiTime = 1042,
    aircraftRouteDeviation = 1020,
    routeDistanceChange = 1021,
    routeEteChange = 1022,
    routeIntersectsArea = 1023,
    routeNotIntersectArea = 1024,
    aircraftIrregularOperation = 1030,
    aircraftCallsignChange = 1031,
    aircraftIsHolding = 1032,
    aircraftOutOfHolding = 1033,
    aircraftIsDiverting = 1034,
    aircraftEmergencyBeaconCode = 1035,
    aircraftMonitorStatus = 1036,
    aircraftAltitudeChangeRate = 1043,
    aircraftPositionUpdateLate = 1044,
    aircraftFuelBelowPlanned = 1045,
    aircraftAltitudeDeviationFromPlanned = 1046,
    aircraftGoAroundDetected = 1047,
    aircraftFuelOnBoardChanged = 1048,
    aircraftOut = 1101,
    aircraftOff = 1102,
    aircraftOn = 1103,
    aircraftIn = 1104,
    messageReceived = 1106,
    messageSent = 1107,
    aircraftImpactFca = 1200,
    aircraftImpactDelay = 1201,
    aircraftImpactReroute = 1202,
    aircraftImpactVolcAsh = 1203,
    aircraftImpactSigmet = 1204,
    aircraftImpactConvSigmet = 1211,
    aircraftImpactAIRMET = 1205,
    aircraftImpactPIREPIcing = 1206,
    aircraftImpactPIREPTurb = 1213,
    aircraftImpactWatch = 1207,
    aircraftImpactWarning = 1208,
    aircraftImpactTurbulence = 1209,
    aircraftImpactEDRTurb = 1212,
    aircraftImpactIcing = 1210,
    aircraftImpactDSUA = 1214,
    aircraftImpactTAPs = 1215,
    aircraftImpactIATATurb = 1216,
    aircraftImpactGTGNTurb = 1217,
    aircraftImpactContrail = 1218,
    aircraftTcf = 1219,
    fpmLateAtPosition = 1300,
    fpmFobAlertLVL1 = 1301,
    fpmFobAlertLVL2 = 1302,
    fpmFobAlertLVL3 = 1303,
    fpmLowAtPosition = 1304,
    fpmMinOffRouteAtPosition = 1305,
    fpmNMOffRouteAtPosition = 1306,
    fpmPosRepNotReceived = 1307,
    fpmMinPriorToEtopsEntry = 1308,
    fpmMinPriorToRdspchPoint = 1309,
    fpmMessageReceived = 1310,
    fpmTurbulenceAlert = 1311,
    airportFlightCatMETAR = 4001,
    airportVisibilityMETAR = 4010,
    airportCeilingMETAR = 4011,
    airportWindsMETAR = 4002,
    airportWindGustsMETAR = 4012,
    airportMETARUpdate = 4013,
    airportFlightCatTAF = 4014,
    airportVisibilityTAF = 4015,
    airportCeilingTAF = 4016,
    airportWindsTAF = 4017,
    airportTAFUpdate = 4018,
    airportRVR = 4003,
    airportDepartureDelay = 4004,
    airportArrivalDelay = 4005,
    airportGroundStop = 4006,
    airportGroundDelay = 4019,
    airportClosureFAA = 4007,
    airportDiversionsTo = 4009,
    airportDiversionCapacity = 4021,
    airportMonitorStatus = 4020,
    airportDepartureRate = 4022,
    airportArrivalRate = 4023,
    airportDeicingActive = 4024,
    airportFlightsHoldingInto = 4025,
    fpmNewNotamForAirport = 4300,
    fpmNewNotamForFir = 4301,
    weatherGraphicUpdated = 2001,
    severeWeatherAlert = 2002,
    rerouteAdvisoryUpdated = 2003,
    myFleetRemotelyUpdated = 3001,
    routeReceived = 3002,
    emailAlertLimitHit = 9001,
    wavSoundAlertError = 9002,
    emailAlertSendFailure = 9003,
    errorOpeningLogFile = 9004,
    errorStartingVoiceSys = 9005,
    voiceTest = 9990,
    eMailTest = 9991,
    loggingEnabled = 9995,
    loggingDisabled = 9996,
    feStartup = 9997,
    feShutdown = 9998
}
